<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            カレンダー
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-3">
                    <button (click)="mode = 'navigator';" type="button" class="btn btn-block btn-primary">日付指定</button>
                </div>
                <div class="col-sm-3">
                    <button (click)="mode = 'day';" type="button" class="btn btn-block btn-primary">日表示</button>
                </div>
                <div class="col-sm-3">
                    <button (click)="mode = 'week';" type="button" class="btn btn-block btn-primary">週表示</button>
                </div>
                <div class="col-sm-3">
                    <button (click)="mode = 'month';" type="button" class="btn btn-block btn-primary">月表示</button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3" [hidden]="mode == 'navigator'">
                    <button type="button" class="btn btn-block btn-success" (click)="previous()">前</button>
                </div>
                <div class="col-sm-6"></div>
                <div class="col-sm-3" [hidden]="mode == 'navigator'">
                    <button type="button" class="btn btn-block btn-success" (click)="next()">次</button>
                </div>
            </div>
            <div class="row" [hidden]="mode != 'navigator'">
                <div class="col-sm-12">
                    <daypilot-navigator [config]="configNavi" [(date)]="calendarDate" (dateChange)="changeDate($event)"></daypilot-navigator>
                </div>
            </div>
            <div class="row" [hidden]="mode != 'day'">
                <div class="col-sm-12">
                    <daypilot-calendar #dayCalendar [events]="events" [config]="configDay" (viewChange)="viewChange()"></daypilot-calendar>
                </div>
            </div>
            <div class="row" [hidden]="mode != 'week'">
                <div class="col-sm-12">
                    <daypilot-calendar #weekCalendar [events]="events" [config]="configWeek" (viewChange)="viewChange()"></daypilot-calendar>
                </div>
            </div>
            <div class="row" [hidden]="mode != 'month'">
                <div class="col-sm-12">
                    <daypilot-month #monthCalendar [config]="configMonth" [events]="events"></daypilot-month>
                </div>
            </div>
        </div>
    </div>
</div>
<div bsModal #modal="bs-modal" class="modal fad calendar" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">買取情報</h4>
                <button (click)="editOrder()" class="btn btn-primary" style="margin-left: 20px;">編集</button>
                <button type="button" class="close" (click)="modal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="card-body" ybAddress [ybAutocompleteMode]="'off'" #address="ybAddress">
                    <fieldset [disabled]="true">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">区分</label>
                            <div class="col-md-9">
                                <select class="form-control" [(ngModel)]="orderHead.status">
                                    <option *ngFor="let item of classifications"
                                            [value]="item.value">{{ item.value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">部門</label>
                            <div class="col-md-9">
                                <select class="form-control" [(ngModel)]="orderHead.department">
                                    <option *ngFor="let item of departments"
                                            [value]="item.value">{{ item.value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">お名前</label>
                            <div class="col-md-9">
                                <input type="text" [(ngModel)]="orderHead.name" class="form-control"
                                       placeholder="お名前">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">受付日</label>
                            <div class="col-md-3">
                                <wj-input-date style="width:100%;" style="width:100%;"
                                               [(value)]="orderHead.orderDate" [format]="'yyyy/MM/dd'"
                                               [isRequired]="false"
                                               [placeholder]="'受付日'"></wj-input-date>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">買取開始日時</label>
                            <div class="col-md-3">
                                <wj-input-date-time style="width:100%;" [(value)]="orderHead.startDate" [format]="'yyyy/MM/dd HH:mm'" [isRequired]="false" [placeholder]="'買取開始日時'">
                                </wj-input-date-time>
                            </div>
                            <label class="col-md-3 form-control-label d-none d-lg-block">買取終了日時</label>
                            <div class="col-md-3">
                                <wj-input-date-time style="width:100%;" [(value)]="orderHead.endDate" [format]="'yyyy/MM/dd HH:mm'" [isRequired]="false" [placeholder]="'買取終了日時'">
                                </wj-input-date-time>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">メモ</label>
                            <div class="col-md-9">
                                        <textarea type="text" [(ngModel)]="orderHead.memo" class="form-control"
                                                  placeholder="メモ"></textarea>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">誕生日</label>
                            <div class="col-md-3">
                                <wj-input-date style="width:100%;" [(value)]="orderHead.birthDay"
                                               [format]="'yyyy/MM/dd'" [isRequired]="false"
                                               [placeholder]="'誕生日'"></wj-input-date>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">郵便番号</label>
                            <div class="col-md-6">
                                <input type="text" [(ngModel)]="orderHead.postalCode" class="form-control"
                                       placeholder="郵便番号" ybPostalCode>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">都道府県</label>
                            <div class="col-md-9">
                                <input type="text" [(ngModel)]="orderHead.state" class="form-control"
                                       placeholder="都道府県"
                                       ybRegion>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">市区町村</label>
                            <div class="col-md-9">
                                <input type="text" [(ngModel)]="orderHead.city" class="form-control"
                                       placeholder="市区町村"
                                       ybLocality>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">町名</label>
                            <div class="col-md-9">
                                <input type="text" [(ngModel)]="orderHead.street" class="form-control"
                                       placeholder="町名"
                                       ybStreet>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">建物</label>
                            <div class="col-md-9">
                                <input type="text" [(ngModel)]="orderHead.building" class="form-control"
                                       placeholder="建物"
                                       ybExtended>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">電話番号</label>
                            <div class="col-md-9">
                                <input type="text" [(ngModel)]="orderHead.telephone" class="form-control"
                                       placeholder="電話番号"
                                       ybRegion>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">身分証明</label>
                            <div class="col-md-9">
                                <wj-combo-box style="width:100%;" [itemsSource]="['免許書','保険証', '住民票写し']"
                                              [wjModelProperty]="'orderHead.identityType'"
                                              [isEditable]="true"></wj-combo-box>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">身分証明番号</label>
                            <div class="col-md-9">
                                <input type="text" [(ngModel)]="orderHead.identityNumber" class="form-control"
                                       placeholder="身分証明番号">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label d-none d-lg-block">合計金額</label>
                            <div class="col-md-9">
                                {{orderHead.total| currency : 'JPY': true}}
                                (消費税: {{orderHead.tax| currency : 'JPY': true}})
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <wj-multi-row #orderLineGrid [isReadOnly]="mode == 'view'" [itemsSource]="orderLine" [layoutDefinition]="orderLineDefinition"></wj-multi-row>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="modal.hide()">閉じる</button>
            </div>
        </div>
    </div>
</div>
